import { useEffect, useRef, useState } from "react";
type UseInViewOptions = IntersectionObserverInit;

const useInViewportLoad = (options?: UseInViewOptions) => {
  const [hasBeenInView, setHasBeenInView] = useState(false);
  const ref = useRef<any>(null);

  useEffect(() => {
    const element = ref.current;
    if (!element || hasBeenInView) return;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setHasBeenInView(true);
        observer.disconnect(); // 触发后停止观察
      }
    }, options);

    observer.observe(element);

    return () => observer.disconnect();
  }, [options, hasBeenInView]);

  return [ref, hasBeenInView] as const;
};

export default useInViewportLoad;
